<template>
    <router-view />
</template>

<script>
export default {
    name: 'Solution-Layout'
}
</script>